/**
 * Horizontal padding shared between the block-creator chrome (StepView) and the
 * block-library-creator-list rows/search/loading. Kept as a single definition so the
 * library list stays visually aligned with the creator chrome — do NOT duplicate this
 * value into either feature (drift risk).
 */
export const DEFAULT_CREATOR_PADDING = 'px-5!';
